import {createElement, Component, PropTypes} from 'rlink-react';
/* eslint-disable react/prop-types */
import hoistNonReactStatics from 'hoist-non-react-statics';

import {mergeStaticOptions} from 'rlink-utils/object';

export default function ExposeLifecycle (WrappedComponent) {
  class ExposeLifecycleWrapComponent extends Component {

    componentWillReceiveProps (nextProps) {
      if ( this.props.onComponentWillRecieveProps ) {
        this.props.onComponentWillRecieveProps(nextProps);
      }
      if ( this.props.onPropsChange ) {
        this.props.onPropsChange(nextProps);
      }
    }
    componentWillMount () {
      if ( this.props.onComponentWillMount ) {
        this.props.onComponentWillMount(this.props);
      }
      if ( this.props.onPropsChange ) {
        this.props.onPropsChange(this.props);
      }
    }
    componentWillUnmount () {
      if (this.props.onComponentWillUnmount) {
        this.props.onComponentWillUnmount(this.props);
      }
      if ( this.props.onPropsChange ) {
        // similar to ref prop behavior
        this.props.onPropsChange(null);
      }
    }


    render () {

      let {
        children,
        /* eslint-disable no-unused-vars */
        onComponentWillMount,
        onComponentWillRecieveProps,
        onComponentWillUnmount,
        onPropsChange,
        /* eslint-enable no-unused-vars */
        ...props
      } = this.props;

      if (children) {
        return <WrappedComponent {...props}>{children}</WrappedComponent>;
      } else {
        return <WrappedComponent {...props} />;
      }

    }
  }
  mergeStaticOptions(ExposeLifecycleWrapComponent, {
    propTypes: WrappedComponent.propTypes,
    defaultProps: WrappedComponent.defaultProps,
  });
  mergeStaticOptions(ExposeLifecycleWrapComponent, {
    propTypes: {
      onComponentWillMount: PropTypes.func,
      onComponentWillRecieveProps: PropTypes.func,
      onComponentWillUnmount: PropTypes.func,
      onPropsChange: PropTypes.func,
    },
  });
  hoistNonReactStatics(ExposeLifecycleWrapComponent, WrappedComponent);
  ExposeLifecycleWrapComponent.displayName = `ExposeLifecycle(${WrappedComponent.displayName || WrappedComponent.name || 'WrappedComponent'})`;

  return ExposeLifecycleWrapComponent;
}



// WEBPACK FOOTER //
// ./lib/rlink-expose-lifecycle.jsx